module.exports = __webpack_public_path__ + "img/weather_pause.e9b5952e.svg";